<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div
            class="w-100 mb-3 d-flex align-items-center justify-content-between"
          >
            <h1>زمان رزرو شده در هر گروه‌بندی (جلسه)</h1>
          </div>
          <filters-wrapper @submitFilters="setFilters">
            <range-date-picker
              class="w-24 filters-width"
              label="بازه‌ی تاریخ جلسات رزرو شده را وارد کنید"
              @getDateRange="setDateRange"
            ></range-date-picker>
            <MasterPicker
              class="w-24 filters-width"
              @getMaster="setMasterUserId"
            ></MasterPicker>
            <price-category-picker
              class="w-24 filters-width"
              @getPriceCategory="setPriceCategoryId"
            ></price-category-picker>
            <loyalty-discount-level-picker
              class="w-24 filters-width"
              @getLoyaltyDiscountId="setLoyaltyDiscountId"
            ></loyalty-discount-level-picker>
            <language-picker
              class="w-24 filters-width"
              @getLanguage="setLanguageId"
            ></language-picker>
            <day-of-week-picker
              class="w-24 filters-width"
              @getDayOfWeek="setDayOfWeek"
            ></day-of-week-picker>
          </filters-wrapper>

          <div class="my-2">
            <!-- Table Top Start -->
            <b-row>
              <b-col cols="12">
                <general-polar-area-chart
                  ref="chart"
                  :getChartData="getPriceCategoryCountChartData"
                >
                </general-polar-area-chart>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      reservationCategoryFilters: {
        pageNumber: 1,
        count: 50,
        fromDate: null,
        toDate: null,
        masterUserId: null,
        priceCategoryId: null,
        sexuality: null,
        fromBirthDate: null,
        toBirthDate: null,
        countryId: null,
        cityId: null,
        jobId: null,
        scheduleLoyaltyDiscountTitleId: null,
        vipUserId: null,
        languageId: null,
        lessonLanguageId: null,
        dayOfWeek: null,
        dayLightType: null,
      },
    };
  },
  methods: {
    setFilters() {
      this.$refs?.chart?.sendChartRequest();
    },
    setDayOfWeek(dayOfWeek) {
      this.reservationCategoryFilters.dayOfWeek = dayOfWeek;
    },
    setLoyaltyDiscountId(loyaltyDiscountId) {
      this.reservationCategoryFilters.scheduleLoyaltyDiscountTitleId =
        loyaltyDiscountId;
    },
    setLanguageId(languageId) {
      this.reservationCategoryFilters.languageId = languageId;
    },
    setMasterUserId(master) {
      this.reservationCategoryFilters.masterUserId = master
        ? master.userId
        : null;
    },
    setChartType(chartType) {
      this.reservationCategoryFilters.type = chartType;
    },
    setPriceCategoryId(priceCategoryId) {
      this.reservationCategoryFilters.priceCategoryId = priceCategoryId;
    },
    setPriceCategory(priceCategoryId) {
      this.reservationCategoryFilters.priceCategoryId = priceCategoryId;
    },
    setDateRange(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.reservationCategoryFilters.fromDate = new Date(
          dateRange[0]
        ).toISOString();
        this.reservationCategoryFilters.toDate = new Date(
          dateRange[1]
        ).toISOString();
      } else {
        this.reservationCategoryFilters.fromDate = null;
        this.reservationCategoryFilters.toDate = null;
      }
    },
    async getPriceCategoryCountChartData(_this) {
      try {
        this.isLoading = true;
        let that = this;
        let getMostSchaduleCountByPriceCategory =
          new GetMostSchaduleCountByPriceCategory(_this);
        getMostSchaduleCountByPriceCategory.setRequestParamDataObj(
          that.reservationCategoryFilters
        );
        await getMostSchaduleCountByPriceCategory.fetch((res) => {
          _this.chartOptions.labels = [];
          _this.chartOptions.series = [];
          if (res.length > 0) {
            res.forEach((item) => {
              _this.chartOptions.labels.push(item.title);
              _this.chartOptions.series.push(item.value);
            });
            _this.chartOptions.dataLabels["formatter"] = function (val, opts) {
              return `${Intl.NumberFormat("en-US").format(
                +opts["w"]["globals"]["series"][opts["seriesIndex"]]
              )} جلسه`;
            };
            _this.chartOptions["tooltip"]["y"] = {
              formatter: (value) =>
                `${Intl.NumberFormat("en-US").format(+value)} جلسه`,
            };
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    GeneralPolarAreaChart,
    BCard,
    BRow,
    BCol,
    BOverlay,
    FiltersWrapper,
    SearchInput,
    RangeDatePicker,
    PriceCategoryPicker,
    MasterPicker,
    LoyaltyDiscountLevelPicker,
    LanguagePicker,
    DayOfWeekPicker,
  },
};
import { BCard, BRow, BCol, BOverlay } from "bootstrap-vue";
import FiltersWrapper from "@/views/components/Utils/FiltersWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import GeneralPolarAreaChart from "@/views/dashboard/analytics/UserReport/GeneralPolarAreaChart.vue";
import { GetMostSchaduleCountByPriceCategory } from "@/libs/Api/UserReport";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";
import LoyaltyDiscountLevelPicker from "@/views/components/ScheduleLoyaltyDiscount/LoyaltyDiscountLevelPicker.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import DayOfWeekPicker from "@/views/components/Utils/DayOfWeekPicker.vue";
</script>